import api, { setToken } from '../index';

export function getAttempts(data) {
  return (api.get(`/schedule/homework/${data.homeworkId}/blocks${data.homeworkBlockId ? '/' + data.homeworkBlockId : ''}`, setToken(data.token)));
}